import { useQuery, useMutation } from 'react-query'
import { notification } from 'antd'
import { getMerchantApplicationPreFill, submitMerchantApplication, SubmitMerchantApplicationRequest } from './merchantApplicationApi'

export const useMerchantApplicationPreFillQuery = () => {
  return useQuery(['merchant-application', 'pre-fill'], getMerchantApplicationPreFill, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })
}

export const useSubmitMerchantApplicationMutation = (onSuccess?: () => void, onError?: () => void) => {
  return useMutation(
    (request: SubmitMerchantApplicationRequest) => submitMerchantApplication(request),
    {
      onSuccess: () => {
        notification.success({ message: 'Application submitted successfully!' })
        onSuccess?.()
      },
      onError: () => {
        notification.error({ message: 'Failed to submit application. Please try again.' })
        onError?.()
      },
    }
  )
}
